// src/ProjectIntro.js
import React, { useRef } from 'react';
import { fileToDataURL } from './utils';

const assessors    = ['Jon McNatt','Mike McNatt','Tommy Carroll'];
const projectTypes = ['Assessment','Clearance','Addendum'];

export default function ProjectIntro({ data, onChange }) {
  const { assessor, projectName, projectType, dateTime, propertyPhoto } = data;
  const change = (field, val) => onChange(field, val);

  // Ref for the hidden camera‐capture input
  const fileInputRef = useRef(null);

  // Handler when user picks from library
  const onFileChange = async e => {
    const f = e.target.files[0];
    if (!f) return;
    const url = await fileToDataURL(f);
    change('propertyPhoto', url);
    e.target.value = null; // reset so same file can be picked again
  };

  // Handler when user takes a photo via native camera
  const onCaptureChange = async e => {
    const f = e.target.files[0];
    if (!f) return;
    const url = await fileToDataURL(f);
    change('propertyPhoto', url);
    e.target.value = null;
  };

  return (
    <div className="border border-gray-300 p-4 mb-6 rounded-lg">
      <h2 className="text-xl font-semibold mb-4">Project Information</h2>

      {/* Line 1 */}
      <div className="flex flex-col md:flex-row gap-4 mb-4">
        <select
          className="flex-1 border border-gray-300 rounded px-2 py-1"
          value={assessor}
          onChange={e => change('assessor', e.target.value)}
        >
          <option value="">Select Assessor…</option>
          {assessors.map(a => <option key={a} value={a}>{a}</option>)}
        </select>

        <input
          className="flex-1 border border-gray-300 rounded px-2 py-1"
          type="text"
          placeholder="Project Name"
          value={projectName}
          onChange={e => change('projectName', e.target.value)}
        />
      </div>

      {/* Line 2 */}
      <div className="flex flex-col md:flex-row gap-4 mb-4">
        <select
          className="flex-1 border border-gray-300 rounded px-2 py-1"
          value={projectType}
          onChange={e => change('projectType', e.target.value)}
        >
          <option value="">Select Project Type…</option>
          {projectTypes.map(pt => <option key={pt} value={pt}>{pt}</option>)}
        </select>

        <div className="flex-1 border border-gray-300 rounded px-2 py-1 bg-gray-100 select-none">
          {dateTime}
        </div>
      </div>

      {/* Line 3 – Photo controls */}
      <div className="mb-4">
        <label className="block mb-1 font-medium">Property Photo:</label>
        <div className="flex items-center gap-4">
          {/* 1) Choose existing file */}
          <input
            type="file"
            accept="image/*"
            onChange={onFileChange}
          />

          {/* 2) Hidden capture input for native camera */}
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            capture="environment"
            style={{ display: 'none' }}
            onChange={onCaptureChange}
          />

          {/* Trigger the native camera input */}
          <button
            className="bg-green-500 text-white px-3 py-1 rounded"
            onClick={() => fileInputRef.current && fileInputRef.current.click()}
          >
            Take Photo
          </button>
        </div>

        {/* Preview & delete */}
        {propertyPhoto && (
          <div className="mt-2">
            <img
              src={propertyPhoto}
              alt=""
              className="max-w-xs mb-2 rounded"
            />
            <button
              className="bg-red-500 text-white px-3 py-1 rounded"
              onClick={() => {
                if (window.confirm('Delete this property photo?')) {
                  change('propertyPhoto', null);
                }
              }}
            >
              Delete Photo
            </button>
          </div>
        )}
      </div>
    </div>
  );
}